var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCepiDjathtasSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 89 81.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d3943;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2658.88,
    y1: -870.09,
    x2: -2657.94,
    y2: -869.15,
    gradientTransform: "translate(-77353.76 -215864.38) rotate(-90) scale(81.2 -89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ede5f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ede8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6a6870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#716d77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#84818a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#a5a0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#d2ccd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ede5f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#efedf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ede5f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e0dae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#bfbac5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8b8790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6a6870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#716d77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#848189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#a5a0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#d2ccd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#d6d0da"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9583",
    className: "cls-2",
    d: "M70.68,18.63H20.43L0,0H89V81.2l-18.32-16.72V18.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9584",
    className: "cls-1",
    d: "M75.62,13.47H22.97L8.2,0H89V73.72l-13.39-12.21V13.47Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCepiDjathtasSilver);
export default __webpack_public_path__ + "static/media/cepi_djathtas_silver.61c2b5884ab5f70db01d7fb228d43c55.svg";
export { ForwardRef as ReactComponent };